<template>
  <div class="step-active">
    <div id="content-follow-tip" class="tip-active">
      <BarFollow :wechat="wechat" :isShowHand="isShowHand" @follow="$emit('follow')"></BarFollow>
    </div>
    <div class="follow-step">
      <div class="step">
        <div class="serial">1</div>
        <div class="flex-center">
          点击
          <BtnFollow :activable="false" class="small btn-follow"></BtnFollow>按钮跳转至微信
        </div>
      </div>
      <div class="next-arrow"></div>
      <div class="step">
        <div class="serial">2</div>
        <div class="flex-center">
          <span class="stronger">按+号</span>添加公众号
        </div>
      </div>
      <div class="next-arrow"></div>
      <div class="step">
        <div class="serial">3</div>
        <div class="flex-center">
          <span class="stronger">激活课程</span>开始学习
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import BarFollow from './BarFollow.vue';
import BtnFollow from './BtnFollow.vue';
@Component({
  components: {
    BarFollow,
    BtnFollow,
  },
})
export default class StepActive extends Vue {
  @Prop({ type: Boolean, default: false }) isShowHand!: boolean;
  @Prop({ type: String, default: 'Python 小课' }) wechat!: string;
}
</script>

<style lang="scss" scoped>
.step-active {
  width: 100%;
  .tip-active {
    display: flex;
    align-items: center;
    height: 140px;
    padding: 0px 23px;
    background: #f5f5f7;
  }
  .follow-step {
    margin-top: 8px;
    padding: 39px 0px 57px 39px;
    background: #f5f5f7;
    .serial {
      display: inline-block;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 51px;
      height: 51px;
      color: #fff;
      font-weight: 500;
      font-size: 34px;
      background: #5444c6;
      border-radius: 50%;
    }
    .next-arrow {
      width: 51px;
      height: 29px;
      margin: 16px 0px 20px 0px;
      background: url('../assets/next-arrow.svg') center center/26px 29px
        no-repeat;
    }
    .step {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 34px;
      .serial {
        margin-right: 35px;
      }
      .btn-follow {
        margin: 0 15px;
      }
      .stronger {
        color: #fa6755;
        font-weight: 600;
      }
    }
  }
}
.flex-center {
  display: flex;
  align-items: center;
}
</style>
